// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__2OZbu","active":"Uploader_active__1jA-l"};